<template>
  <div class="w-100 text-center d-flex-wrap align-items-center justify-content-center mt-2 mb-3">
    <b-button variant="secondary" v-if="current_page!=1" @click="current_page=1; refreshTable();"><<</b-button>
    <b-button variant="secondary" v-if="current_page!=1"
              @click="current_page-10>=1 ? current_page=current_page-10 : current_page=1; refreshTable();"><
    </b-button>
    <b-button :variant="current_page==page ? 'primary':'secondary'" v-for="page in last_page"
              @click="current_page=page;" v-bind:key="page" v-if="page<(current_page+5) && (page>current_page-5)">
      {{ page }}
    </b-button>

    <b-button variant="secondary" v-if="current_page!=last_page"
              @click="current_page+10<=last_page ? current_page=current_page+10 : current_page=last_page; refreshTable();">
      >
    </b-button>
    <b-button variant="secondary" v-if="current_page!=last_page"
              @click="current_page=last_page; refreshTable();"> >>
    </b-button>
  </div>
</template>

<script>
export default {
  props:['cPage','refreshTable','last_page'],
  watch:{
    current_page(){
      this.$emit('changePage',this.current_page)
    }
  },
  data(){
    return {
      current_page:this.cPage
    }
  }
}
</script>

<style scoped>

</style>